import { Check, Close } from "@mui/icons-material"
import { Box, ListItem, ListItemProps, ListItemText, Typography } from "@mui/material"
import { grey } from "@mui/material/colors"
import { FC } from "react"

export interface DetailListItem {
  title: string
  value: any
  position?: "bottom" | "top"
}

export type DetailItemProps = ListItemProps &
  DetailListItem & {
    index?: number
    itemBorder?: boolean
  }
const DetailItem: FC<DetailItemProps> = ({ title, value, position, index, itemBorder, ...props }) => {
  const isBoolean = typeof value === "boolean"
  const isNumber = typeof value === "number"

  const action = isBoolean ? (
    value ? (
      <Check color='success' />
    ) : (
      <Close color='error' />
    )
  ) : isNumber ? (
    <Typography>{value}</Typography>
  ) : (
    <Typography dir='auto'>{value}</Typography>
  )

  const _position = position || value?.length > 46 ? "bottom" : "top"

  return (
    <>
      <ListItem
        sx={{
          bgcolor: index % 2 === 1 && itemBorder ? grey[200] : null
        }}
        secondaryAction={_position === "top" && action}
        {...props}
      >
        <ListItemText
          primary={
            <Typography
              sx={{
                fontWeight: itemBorder ? 600 : 500
              }}
            >
              {title}
            </Typography>
          }
          secondary={_position === "bottom" && <Box sx={{ mt: 1, wordBreak: "break-word" }}>{value}</Box>}
        />
      </ListItem>
    </>
  )
}

export default DetailItem
